import clsx from 'clsx';
import React from 'react';

import { PriceType } from 'src/services/api/productsApi';

interface Props {
  type: PriceType;
  onToggleType: (tab: PriceType) => void;
}
export const PriceTypeToggle: React.FC<Props> = ({ type, onToggleType }) => {
  const handleToggleType = (event: React.MouseEvent, tab: PriceType) => {
    event.preventDefault();
    onToggleType(tab);
  };

  return (
    <div className="flex items-center gap-2 p-1 border border-non-hover-border border-solid text-[12px] rounded">
      <button
        onClick={(event) => handleToggleType(event, PriceType.OneTime)}
        style={{ width: '50%' }}
        className={clsx(
          'flex items-center justify-center border border-t-0 border-b-0 border-l-0 border-r-0 cursor-pointer h-6 max-w-1/2',
          {
            'text-black-heading rounded-[2px] bg-secondary-hover font-medium':
              type === PriceType.OneTime,
            'bg-transparent text-gray-small font-normal':
              type !== PriceType.OneTime,
          },
        )}
      >
        One time
      </button>
      <button
        style={{ width: '50%' }}
        className={clsx(
          'flex items-center justify-center border border-t-0 border-b-0 border-l-0 border-r-0 cursor-pointer h-6 max-w-1/2',
          {
            'text-black-heading rounded-[2px] bg-secondary-hover font-medium':
              type === PriceType.Recurring,
            'bg-transparent text-gray-small font-normal':
              type !== PriceType.Recurring,
          },
        )}
        onClick={(event) => handleToggleType(event, PriceType.Recurring)}
      >
        Recurring
      </button>
    </div>
  );
};
